import ContentTypeAutoImportConfigField from '@/ecm/models/contentType/autoImport/ContentTypeAutoImportConfigField'
import Utils from '@/ecm/common/Utils'
import { Field } from 'vee-validate'
export default class ContentTypeAutoImportConfig {
    constructor(dto) {
        this.uuid = Utils.object.getUUID()
        this.contentTypeID = ''
        this.description = ''
        this.emailAccount = ''
        this.emailPassword = ''
        this.emailPort = ''
        this.emailServer = ''
        this.emailUseSSL = "false"
        this.serviceID = 1
        this.oAuthRefreshToken = ''
        this.rootFolder = ''
        this.oAuthAccessToken = ''
        this.folderList = []
        this.fields = []
        this.readExistingDocuments = true

        if (dto) {
            this.id = dto.Id
            this.contentTypeID = dto.ContentTypeID
            this.description = dto.Description
            this.emailAccount = dto.EmailAccount
            this.emailPassword = dto.EmailPassword
            this.emailPort = dto.EmailPort
            this.emailServer = dto.EmailServer
            this.emailUseSSL = dto.EmailUseSSL 
            this.serviceID = dto.ServiceID
            this.oAuthRefreshToken = dto.OAuthRefreshToken
            this.rootFolder = dto.RootFolder
            this.readExistingDocuments = dto.ReadExistingDocuments
            this.fields = dto.Fields.map(function (dto) { return new ContentTypeAutoImportConfigField(dto) })
        }
    }

    toDto() {
        return {
            Id: this.id,
            ContentTypeID: this.contentTypeID,
            Description: this.description,
            EmailAccount: this.emailAccount,
            EmailPassword: this.emailPassword,
            EmailPort: this.emailPort,
            EmailServer: this.emailServer,
            EmailUseSSL: this.emailUseSSL.toString(),
            ServiceID: this.serviceID,
            OAuthRefreshToken: this.oAuthRefreshToken,
            RootFolder: this.rootFolder,
            ReadExistingDocuments: this.readExistingDocuments,
            Fields: this.fields.map((field) => field.toDto())
        }
    }
}
